import { useEffect, useState } from 'react';

const KEY = 'radar.dismissedAnnouncement';
const read = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
const write = v => { try { localStorage.setItem(KEY, v); } catch (e) { /* ignore */ } };
const COLORS = { info: '#b38d3c', success: '#2e9e6b', warn: '#b48e3c' };

export default function AnnouncementBanner() {
  const [a, setA] = useState(null);
  useEffect(() => {
    let live = true;
    fetch('/api/announcement').then(r => r.json()).then(d => {
      if (live && d && d.announcement && d.announcement.id !== read()) setA(d.announcement);
    }).catch(() => {});
    return () => { live = false; };
  }, []);
  if (!a) return null;
  return (
    <div role="status" style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '10px 14px', background: '#13161c', color: '#f4f1ec', borderLeft: `4px solid ${COLORS[a.level] || COLORS.info}`, fontSize: 14 }}>
      <span style={{ flex: 1 }}>{a.text}</span>
      <button type="button" aria-label="Dismiss" onClick={() => { write(a.id); setA(null); }}
        style={{ background: 'none', border: 0, color: 'inherit', fontSize: 18, cursor: 'pointer', minWidth: 32, minHeight: 32 }}>×</button>
    </div>
  );
}
